import React from "react";

import EpisodeSharedWithMeView from "../modules/EpisodesSharedWithMe/EpisodeSharedWithMeView";

export default function EpisodesSharedWithMe() {
  return <EpisodeSharedWithMeView />;
}
